import React from 'react';

const Hero = () => {
  return (
    <section
      className="relative bg-cover bg-center py-24 text-center"
      style={{ backgroundImage: "url('/images/hero-bg.webp')" }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-blue-900/50 to-teal-900/30"></div>
      <div className="container mx-auto px-4 relative z-10">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Digital Health Hub: Empowering Kenya & Beyond with Innovative Surveillance
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-10 max-w-3xl mx-auto">
          Showcasing our platforms, publications, activities, and impacts in epidemiology and health informatics.
        </p>
        <div className="flex justify-center space-x-4 flex-col sm:flex-row gap-4">
          <a
            href="#services"
            className="bg-teal-500 text-white px-8 py-4 rounded-full font-semibold hover:bg-teal-600 transition-all duration-300 hover:scale-105 shadow-md"
          >
            Explore Platforms
          </a>
          <a
            href="#publications"
            className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-teal-500 transition-all duration-300 hover:scale-105 shadow-md"
          >
            View Publications
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;